import { render, staticRenderFns } from "./allPosts.vue?vue&type=template&id=688dc4ee&scoped=true"
import script from "./allPosts.vue?vue&type=script&lang=js"
export * from "./allPosts.vue?vue&type=script&lang=js"
import style0 from "./allPosts.vue?vue&type=style&index=0&id=688dc4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688dc4ee",
  null
  
)

export default component.exports